var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#152FF5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 15.9999,
    cy: 15.9999,
    r: 12.2353,
    fill: "#152FF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78418 12.8087C8.78418 12.4019 9.11576 12.0721 9.52478 12.0721H22.8555C23.4009 12.0721 23.843 12.5118 23.843 13.0542V13.1069C23.843 13.9865 23.255 14.7588 22.4038 14.9974L10.6252 18.2988C10.5271 18.3263 10.4431 18.3821 10.3809 18.4558H23.1024C23.5114 18.4558 23.843 18.7855 23.843 19.1923C23.843 19.5991 23.5114 19.9289 23.1024 19.9289H9.77164C9.22628 19.9289 8.78418 19.4892 8.78418 18.9468V18.7714C8.78418 17.8918 9.37216 17.1195 10.2234 16.8809L22.002 13.5795C22.033 13.5708 22.0626 13.5593 22.0905 13.5453H9.52478C9.11576 13.5453 8.78418 13.2155 8.78418 12.8087Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatus);
export default __webpack_public_path__ + "static/media/ic_status.46514b2a9e96a845fe4642161eb0c27c.svg";
export { ForwardRef as ReactComponent };